import { Directive, Output, HostListener, EventEmitter } from '@angular/core';

@Directive({
  selector: '[mouseWheel]',
  standalone: false,
})
export class MouseWheelDirective {
  @Output() mouseWheelUp = new EventEmitter();
  @Output() mouseWheelDown = new EventEmitter();

  @HostListener('mousewheel', ['$event']) onMouseWheelChrome(event: any) {
    this.handleEvent(event);
  }

  @HostListener('wheel', ['$event']) onMouseWheelFirefox(event: any) {
    this.handleEvent(event);
  }

  @HostListener('onmousewheel', ['$event']) onMouseWheelIE(event: any) {
    this.handleEvent(event);
  }

  handleEvent(_event: any) {
    const event = _event;
    let result = 0;
    const userAgent = navigator.userAgent;

    if (event.wheelDelta) {
      result = event.wheelDelta * -1;
    } else if (event.deltaY) {
      const isDotNet = userAgent.includes('.NET');

      if (isDotNet) {
        result = event.deltaY < 0 ? -100 : 100;
      } else {
        result = event.deltaY * 13;
      }
    }

    if (result < 0) {
      this.mouseWheelDown.emit({ direction: 'up', value: result });
    } else if (result > 0) {
      this.mouseWheelUp.emit({ direction: 'down', value: result });
    }

    // IE
    event.returnValue = false;

    // Chrome + Firefox
    if (event.preventDefault) {
      event.preventDefault();
    }
  }
}
